import GetNotifiedModal from './GetNotifiedModal'

export { GET_NOTIFIED_STEP } from './constants'

export default GetNotifiedModal
